import React from 'react';

const FrontPageRunToGoal = ({ isActiveWomensMode }) => {
    return (
        <>
            {/* FONDO (Reutilizamos la clase que usas en la portada) */}
            <div className='FrontPage--Riddle__Screen__Background'>
                <img src='/img/games/runtogoal/background-1.png' className='FrontPage--Riddle__Screen__Background__Image' alt="Fondo" />
            </div>

            <div className="goal-intro">
                {/* Ocultamos la cancha y ponemos un fondo oscuro para resaltar el logo */}
                <div className="goal-intro__logo-container">
                    {/* Tiro a gol */}
                    <div className='d-flex'>
                        <img src="/img/page/xolos-five.png" className="LogoADSLxZtudia" alt="Logo" style={{ maxWidth: '500px', width: '500px' }} />
                    </div>
                    <p className="goal-intro__text text-uppercase fw-bold" style={{ color: '#fff', textShadow: '-4px 0 #3a4c98, 0 4px #3a4c98, 4px 0 #3a4c98, 0 -4px #3a4c98' }}>Presenta</p>
                    <p className="goal-intro__title fw-bold" style={{ color: '#fff', textShadow: '-6px 0 #3a4c98, 0 6px #3a4c98, 6px 0 #3a4c98, 0 -6px #3a4c98', fontSize: '9.4em' }}>Tiro a la canasta</p>
                </div>

                {/* El balón que cae del cielo y rebota */}
                <img src="/img/games/runtogoal/balon-grande.png" className="goal-intro__ball" alt="Balón" style={{ maxWidth: '350px' }} />
                
                <p className='FooterCredits' style={{ position: 'fixed', bottom: '0', left: '50%', transform: 'translateX(-50%)', fontSize: '30px', color: '#fff' }}>Hecho con ♥ por Five Digital Minds | 2026</p>
            </div>
        </>
    );
};

export { FrontPageRunToGoal };